import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import { DownloadButton } from "../../button/download-button/DownloadButton"
import { Text } from "../../Text/Text"
import { Breadcrumb } from "../../location/breadcrumb/Breadcrumb"


interface OwnProps {
  heroComingSoon?: string; 
  intro: string;
  title: string;
}

export type HeroProps = OwnProps

export const Hero: React.FC<HeroProps> = ({
  heroComingSoon,
  intro,
  title,
}) => {
  const { t } = useTranslation("shared", {
    keyPrefix: "location_pages",
  });

  return (
    <div className="bg-light-wool">
      <div className="max-w-content-width mx-auto text-center px-5 py-8 md:py-16">
        <Breadcrumb currentPage={title} locationsSubPath={true} />
        <div className="mt-5 md:mt-7">
          <Text variant="large-header">{title}</Text>
          {heroComingSoon && (
            <Text variant="large-header">{heroComingSoon}</Text>
          )}
        </div>
        <div className="mt-5 md:mt-7">
          <Text variant="body">{intro}</Text>
        </div>
        <div className="mt-5 md:mt-7">
          <DownloadButton text={t("hero_button_text")} href="/app/" variant="primary-button-sky" />
        </div>
      </div>
    </div>
  )
}
